import { Routes } from '@angular/router';
import { isLoggedInGuard } from './core/guards/is-logged-in.guard';
import { adminGuard } from './core/guards/admin.guard';
import { userGuard } from './core/guards/user.guard';
import { emailConfirmedGuard } from './core/guards/email-confirmed.guard';
import { isLoggedOutGuard } from './core/guards/is-logged-out.guard';
import { emailNotConfirmedGuard } from './core/guards/email-not-confirmed.guard';
import { profileCompleteGuard } from './core/guards/profile-complete.guard';
import { profileIncompleteGuard } from './core/guards/profile-incomplete.guard';
import { mobileDeviceGuard } from './core/guards/mobile-device.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/landing/landing').then((m) => m.Landing),
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
    canActivate: [isLoggedOutGuard],
  },
  {
    path: 'register/photo',
    loadComponent: () =>
      import('./features/auth/register-photo/register-photo').then((m) => m.RegisterPhoto),
    canActivate: [isLoggedInGuard, emailConfirmedGuard, profileIncompleteGuard],
  },
  {
    path: 'confirm-email',
    loadComponent: () =>
      import('./features/auth/confirm-email/confirm-email').then((m) => m.ConfirmEmail),
    canActivate: [isLoggedInGuard, emailNotConfirmedGuard],
  },
  {
    path: 'terms',
    loadComponent: () => import('./features/legal/terms/terms').then((m) => m.Terms),
  },
  {
    path: 'privacy',
    loadComponent: () => import('./features/legal/privacy/privacy').then((m) => m.Privacy),
  },
  {
    path: 'account-delete',
    loadComponent: () =>
      import('./features/legal/account-delete/account-delete').then((m) => m.AccountDelete),
  },
  {
    path: 'services-map',
    loadComponent: () => import('./features/services-map/services-map').then((m) => m.ServicesMap),
  },
  {
    path: 'store',
    loadComponent: () => import('./features/landing/deep-link/deep-link').then((m) => m.DeepLink),
  },
  {
    path: 'post/:id',
    loadComponent: () => import('./features/landing/deep-link/deep-link').then((m) => m.DeepLink),
  },
  {
    path: 'service/:id',
    loadComponent: () => import('./features/landing/deep-link/deep-link').then((m) => m.DeepLink),
  },
  {
    path: 'ad/:id',
    loadComponent: () => import('./features/landing/deep-link/deep-link').then((m) => m.DeepLink),
  },
  {
    path: 'lost/:id',
    loadComponent: () => import('./features/landing/deep-link/deep-link').then((m) => m.DeepLink),
  },
  {
    path: 'found/:id',
    loadComponent: () => import('./features/landing/deep-link/deep-link').then((m) => m.DeepLink),
  },
  {
    path: 'blog/:id',
    loadComponent: () => import('./features/landing/deep-link/deep-link').then((m) => m.DeepLink),
  },
  {
    // On phones, hand the new-pet link off to the app; desktop keeps the web form under /user.
    path: 'user/pet/new',
    loadComponent: () => import('./features/landing/deep-link/deep-link').then((m) => m.DeepLink),
    canMatch: [mobileDeviceGuard],
    data: { appPath: 'user/pet/new' },
  },
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
    canActivate: [isLoggedInGuard, emailConfirmedGuard, adminGuard],
  },
  {
    path: 'purchase/return',
    loadComponent: () =>
      import('./features/purchase-return/purchase-return').then((m) => m.PurchaseReturn),
    canActivate: [isLoggedInGuard, emailConfirmedGuard, profileCompleteGuard, userGuard],
  },
  {
    path: 'user',
    loadChildren: () => import('./features/user/user.routes').then((m) => m.USER_ROUTES),
    canActivate: [isLoggedInGuard, emailConfirmedGuard, profileCompleteGuard, userGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
